import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnChanges {
  @Input() values;
  @Input() minScale;
  public maxValue = 0;
  public currentHover: string;
  public iterations: Array<number>;

  constructor() {}

  ngOnInit() {
    this.maxValue = 0;
    this.values.map((value, index) => {
      this.maxValue += value.value;
    }, this);
    this.values.map(value => {
      value.width = this.minScale
        ? Math.floor((value.value / this.minScale) * 100) + '%'
        : Math.floor((value.value / this.maxValue) * 100) + '%';
    }, this);
  }

  hideRightRadius(index) {
    // Check if bars after this bar has values more than zero
    for (let i = index + 1; i < this.values.length; i++) {
      if (this.values[i].value > 0) {
        return true;
      }
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.iterations = Array(this.values.length).fill(null);
    if (this.minScale > 0) {
      this.maxValue = this.minScale;
    } else {
      let currentMax = 0;
      this.values.map((value, index) => {
        currentMax += value.value;
      }, this);
      this.maxValue = 7800 > currentMax ? 7800 : currentMax;
    }
    this.values.map(value => {
      value.width = Math.floor((value.value / this.maxValue) * 100) + '%';
    }, this);
  }

  toggleTooltip(name?) {
    if (this.currentHover === name) {
      this.currentHover = undefined;
    } else {
      this.currentHover = name;
    }
  }
}
